import { render, staticRenderFns } from "./UploadTitleImage.vue?vue&type=template&id=4ca57bbc&scoped=true&"
import script from "./UploadTitleImage.vue?vue&type=script&lang=ts&"
export * from "./UploadTitleImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca57bbc",
  null
  
)

export default component.exports